import { combineReducers } from 'redux'
import legalAgreements from './legalAgreements'
import signatures from './signatures'

export default combineReducers({
  legalAgreements: legalAgreements.reducer,
  signatures: signatures.reducer,
})
